const $ = window.jQuery;
(async () => {
  const { 
        loadScript,
        loadStyle,
        updateURLParams,
        historyPush
    } = await import(window.theme.modules.utils);
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('main-list', class extends baseComponent.default {
      elements = {
        items: 'list-items',
        subtotal: 'subtotal-price',
        emptylist: 'list-empty',
        list: 'list'
      };

      async render() {
        
         //localStorage.setItem('wishList', '');
        //console.log('render wishList:',localStorage.getItem('wishList'));
        var queryString = window.location.search;       
        queryString = queryString.substring(1);        
        var encodedString = decodeURIComponent(queryString);
        var decodedString = decodeURIComponent(encodedString.replace(/^"|"$/g, ''));
        const submittedwishList = [];
        const currentwishlistarray = [];
        let wishList = localStorage.getItem('wishList');
        console.log('prevlist-wishList', wishList);
        wishList = wishList ? JSON.parse(wishList) : [];
        //const jsonstring = JSON.parse(currentwishlist);
        //const currentwishlistarray = JSON.parse(jsonstring);
        //console.log('currentwishlistarray',currentwishlistarray);
        //console.log('decodedString',decodedString);
        //console.log('encodedString',encodedString);
        
       if(encodedString != '' && encodedString != 'submitted'){
          //const productsData = JSON.parse(decodedString);
          //showPopup(); comeent function to hide replace wishlist popup by megha
          /*productsData.forEach(product => {
              const productHandle = product.product_handle; 
              fetchProductDataByHandle(productHandle, product.variant_sku, product.total, product.list_qty, product.decID, product.decName );
          });*/
        }
        
        // Function to fetch product data by handle
        function fetchProductDataByHandle(handle, variantSKU, total, qty, decID, decName, action ) {
         
            fetch(window.Shopify.routes.root + 'products/'+handle+'.js')
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok ' + response.statusText);
                    }
                    return response.json();
                })
                .then(product => {
                   console.log('Product data:', product);
                    // You can now work with the product JSON data
                  const variantID = getVariantIDBySKU(product, variantSKU);
                  if(action == 'replacewishlist')
                  {
                    displayProductData(product, variantID, total, qty, decID, decName);
                  }
                  if(action == 'addwishlist')
                  {
                    adddisplayProductData(product, variantID, total, qty, decID, decName);
                  }
                  
                })
                .catch(error => {
                    console.error('There was a problem with the fetch operation:', error);
                });
        }

    

        // Function to display product data (example)
        function displayProductData(product, variantID, total, qty, decID, decName) {
          const variant = product.variants.find(v => v.id === variantID);
          const unitPrice = parseFloat(total / qty).toFixed(2);
          let prod_image = '';

              if(variant && variant.featured_image)
              {
                prod_image = variant.featured_image.src;
              }else
              {
                prod_image = product.featured_image;
              }
          submittedwishList.push({
            status: 'active',
            decID:decID,
            decName:decName,
            product:{ id: product.id, handle: product.handle, title: product.title, description: decName, qty: qty, price: unitPrice, total: total},
            variant: {id: variant.id, sku: variant.sku, option1: variant.option1, image: prod_image}
          });
          //console.log('each',submittedwishList)
            wishList = submittedwishList;
            localStorage.setItem('wishList', JSON.stringify(wishList));
        }

        function adddisplayProductData(product, variantID, total, qty, decID, decName) {
          const variant = product.variants.find(v => v.id === variantID);
          const unitPrice = parseFloat(total / qty).toFixed(2);
          let prod_image = '';
          if(variant && variant.featured_image)
              {
                prod_image = variant.featured_image.src;
              }else
              {
                prod_image = product.featured_image;
              }

          wishList.push({
            status: 'active',
            decID:decID,
            decName:decName,
            product:{ id: product.id, handle: product.handle, title: product.title, description: decName, qty: qty, price: unitPrice, total: total},
            variant: {id: variant.id, sku: variant.sku, option1: variant.option1, image: prod_image}
          });
          //console.log('each',currentwishlist)
          localStorage.setItem('wishList', JSON.stringify(wishList));
        }

        function getVariantIDBySKU(product, sku) {
            let variantID = null;
            product.variants.forEach(variant => {
                if (variant.sku === sku) {
                    variantID = variant.id;
                }
            });
            return variantID;
        }

        function showPopup() {
            document.getElementById('overlay').style.display = 'block';
            document.getElementById('popup').style.display = 'block';
        }

        function hidePopup() {
            document.getElementById('overlay').style.display = 'none';
            document.getElementById('popup').style.display = 'none';
        }

        document.getElementById('replaceBtn').addEventListener('click', async function() {
          //alert('replace');
            const productsData = JSON.parse(decodedString);
            productsData.forEach(product => {
                const productHandle = product.product_handle; 
                fetchProductDataByHandle(productHandle, product.variant_sku, product.total, product.list_qty, product.decID, product.decName, 'replacewishlist' );
            });
          setTimeout(() => {
            console.log("hello ssp");
            document.querySelector("main-list").update();
            hidePopup();
            
            }, 2000);
            
           //document.querySelector("main-list").update();
        });

        document.getElementById('addBtn').addEventListener('click', function() {
            const productsData = JSON.parse(decodedString);
            productsData.forEach(product => {
                const productHandle = product.product_handle; 
                fetchProductDataByHandle(productHandle, product.variant_sku, product.total, product.list_qty, product.decID, product.decName, 'addwishlist' );
            });
            setTimeout(() => {
            document.querySelector("main-list").update();
            hidePopup();
            
            }, 2000);
          //document.querySelector("main-list").update();
        });

        document.getElementById('cancelBtn').addEventListener('click', function() {
            //console.log('Current wishlist:', wishlistJSON);
            hidePopup();
        });
        
        /*setTimeout(() => {
            console.log("hello ssp");
            this.update();
        }, 2000);*/
          //this.oldupdate();
        

        this.listenTo('listChange', (e, data) => {
          console.log(">>>>>>>>>>>");
          const source = data.html.querySelector('main-list');

          source.hasAttribute('is-empty')
            ? this.setAttribute('is-empty', '')
            : this.removeAttribute('is-empty');

          this.$subtotal.replaceChildren(...data.html.querySelector(this.elements.subtotal).childNodes);
          // this.$subtotal.innerText = data.html.querySelector(this.elements.subtotal).innerText;
        });
        window.mainlist = this;

        window.addEventListener('message',function(message){
          if(message.origin == "https://embed.forms.app"){
            //window.mainlist.getJSONData();
            //console.log("Updating JSON", message);
          }
          //console.log(message)
        });
        /*
        const form = document.querySelector("#fsForm5609444")
        // Attach an event listener to the form's submit event
        form.addEventListener('submit', (event) => {
            console.log(event);
          event.preventDefault();
            const listInput = document.querySelector("#field158516581");
            if(listInput){
              listInput.value = window.listjson;
            }
        });*/

        
      }

      getJSONData(){
        let wishList = localStorage.getItem('wishList');
      console.log('wishList :',wishList);
        if(wishList){
          wishList = JSON.parse(wishList);
          const userJSON = [];
          
          for(let i = 0; i < wishList.length; i++){
            const listItem = wishList[i];
            
            if(listItem.status == 'deleted')continue;
            userJSON.push({product_handle: listItem.product.handle, variant_sku: listItem.variant.sku, decID: listItem.decID, list_qty: listItem.product.qty, list_status: listItem.status, total: listItem.product.total, decName: listItem.decName});
            
          }
          const listjson = JSON.stringify(userJSON);
          window.listjson = listjson;
          const listInput = document.querySelector("#field158516581");
          if(listInput){
            listInput.value = listjson;
          }
          const formstackWrapper = document.querySelector("#formstack-wrapper");
          const jsonString = JSON.stringify(encodeURIComponent(listjson));
          const encodedString = encodeURIComponent(jsonString);
          let stringWithoutQuotes = encodedString.replace(/^"|"$/g, '');

          var url =window.location.href;
          const index = url.indexOf('?');
          var curl = index === -1 ? url : url.slice(0, index);
          
          const currentURL = curl+'?'+stringWithoutQuotes;

          
          
          if(formstackWrapper){
            formstackWrapper.innerHTML = '<iframe allow="geolocation; microphone; camera;" src="https://embed.forms.app/form/6626d0f806d2c65b15636d9c?utm_source=embed-standard#6626d10780aeca1e1c9ed529='+(encodeURIComponent(listjson))+'&66319280bced03599ec80427='+(encodeURIComponent(currentURL))+'" allowfullscreen="" class="formsapp-iframe standard" style="z-index: 999999; height: 1010px; width: 100vw;"></iframe>';
          }
          return listjson;
        }
      }
      /*update() {
         //alert('update');
        let wishList = localStorage.getItem('wishList');
        console.log('updated-wishList', wishList);
        const format = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });    
        //var continueshoppingurl = window.page.metafields.continueshoppingurl;
        var continueshoppingurl = "https://crowdmerch.com.au/collections";
        var wishlistmsg = window.page.metafields.wishlistmsg;;
        if(wishList){
          wishList = JSON.parse(wishList);
          this.$emptylist.style.display='none';
          let itemsHtml = '<div class="#list-items">'+
'    <div class="#list-items-header">'+
'        <h3 class="#list-items-title">Your list</h3>'+
'        <div class="yourlist_link"><a href="'+continueshoppingurl+'">Continue shopping</a>'+
'        <a href="#" id="clear-wishlist" onclick="clearWishlist()">Clear Wishlist</a></div>'+
'    </div>'+
'    <div class="#list-items-body">';
          let subtotal = 0;
          for(let i = 0; i < wishList.length; i++){
            const listItem = wishList[i];
            console.log('MMMMMlistItem',listItem);
            if(listItem.status == 'active'){
              subtotal = subtotal + parseFloat(listItem.product.total);
          itemsHtml+=
'            <list-item class="#list-item" list-item-row-id="'+(i)+'" list-item-variant-id="'+listItem.variant.id+'" section-id="template--17336574869724__main-list">'+
'                <div class="#list-item-card">'+
'                    <!--<a href="/products/'+(listItem.product.handle)+'?variant='+(listItem.variant.id)+'" class="stretched-link"></a>-->'+
'                    <div class="#list-item-image">'+
'<figure class=" #media       @aspect-ratio:1x1    " style="">'+
'        <div class="    #media-image-wrapper        @abs-image   ">'+
'            <img class="#media-image    @position:center" alt="" loading="lazy" width="1500" height="1500" style="--object-position: ;" src="'+(listItem.variant.image)+'">'+
'        </div>'+
'</figure>'+
'                    </div>'+
'                    <div class="#list-item-meta">'+
'                        <h5 class="#list-item-title">'+listItem.product.title+'</h5>'+             
'                            <p class="#list-item-subtitle">'+listItem.variant.option1+'</p>'+
'                        <!--<div class="#list-item-price">'+
'                            <span class="#list-item-price-final">'+(listItem.product.price)+'</span>'+
'                        </div>-->'+
'                    </div>'+
'                </div>'+
'                <div class="#list-item-side">'+
'                    <div class="#list-item-view">'+                       
'<a id="viewproduct" data-productqty="'+listItem.product.qty+'" data-decoration="'+listItem.decID+'" class="#button  @color:default @size:sm" href="/products/'+(listItem.product.handle)+'?variant='+(listItem.variant.id)+'&productqty='+listItem.product.qty+'&decoration='+listItem.decID+'"><span class="#button-inner">'+
'    <span class="#button-text">'+
'        View'+
'    </span>'+
'</span>'+
'</a>'+
'                    </div>'+
'                    <div class="#list-item-description" data-total="'+listItem.variant.id+'">'+                       
'                        '+listItem.product.qty+' units<br /> with '+(listItem.product.description)+
'                    </div>'+
'                    <div class="#list-item-total" data-total="'+listItem.variant.id+'">'+                       
'                        '+(listItem.product.total)+
'                    </div>'+
'                </div>'+
'                <a class="#list-item-remove" href="#" data-remove="'+listItem.variant.id+'" aria-label="'+listItem.product.title+'">'+
'<svg class="#icon">'+
'    <use href="#svg-icon-x"></use>'+
'</svg>'+
'                </a>'+
'            </list-item>';

            }else if(listItem.status == 'inactive'){
          itemsHtml+=
'            <list-item class="#list-item" list-item-row-id="'+(i)+'" list-item-variant-id="'+listItem.variant.id+'" section-id="template--17336574869724__main-list">'+
'                    <div class="#list-item-deleted">'+          
'                            <p class="#list-item-subtitle">Removed '+listItem.product.title+' <a data-unremove="'+listItem.variant.id+'" href="#">undelete</a></p>'+
'                    </div>'+
'                <a class="#list-item-remove" href="#" data-remove="'+listItem.variant.id+'" aria-label="'+listItem.product.title+'">'+
'<svg class="#icon">'+
'    <use href="#svg-icon-x"></use>'+
'</svg>'+
'                </a>'+
'            </list-item>';

            }
          }
          itemsHtml+=
'					<div class="#list-checkout">'+
'                        <div class="#list-checkout-inner sticky-top">'+
'                                <subtotal-price class="#list-checkout-subtotal-wrapper" section-id="template--17336574869724__main-cart">'+
'                                    <div class="#list-checkout-subtotal">'+
'                                        <div class="main-total">'+
'                                        <h3 class="#list-checkout-subtotal-title">Subtotal</h3>'+
'                                        </div>'+
'                                        <div class="main-subtotal">'+
'                                        <span class="#list-checkout-subtotal-value one" data-subtotal="">'+
'                                            <div class="heading">'+format.format(subtotal)+'</div>'+
                                            '<span>excluding GST</span>'+
'                                        </span>'+
'                                        <span class="#list-checkout-subtotal-value two" data-subtotal="">'+
'                                            <div class="heading">'+format.format(subtotal * 1.1)+'</div>'+
                                            '<span>including GST</span>'+
'                                        </span>'+
'                                        </div>'+
'                                    </div>'+
'                                </subtotal-price>'+
'                                    <div class="#list-checkout-tax-note">'+
'                                        <span>'+((subtotal * 1.1) >= window.discount_trigger_value ? window.wishlist_discount_message : '' )+'</span>'+
'                                    </div>'+
'                        </div>'+
'                    </div>';
          itemsHtml+='<!--<div><p><strong>List JSON:</strong></p>'+this.getJSONData()+'</div>-->';
          itemsHtml+
'    </div>'+
'</div>';
         itemsHtml+= '<div><p class="wishlistmsg">'+wishlistmsg+'</p></div>';
          this.$items.innerHTML = itemsHtml;
        }else{
          this.$list.style.display='none';
        }
      }*/
      /*oldupdate(){
       
        const draftOrderId = localStorage.getItem('ActiveWL');
        console.log('[Wishlist] ActiveWL (draftOrderId):', draftOrderId);
        var continueshoppingurl = "https://crowdmerch.com.au/collections";
        var wishlistmsg = window.page.metafields.wishlistmsg;
        if (!draftOrderId) {
          console.warn('[Wishlist] No ActiveWL found in localStorage. Skipping update.');
          //if (this.$list) this.$list.style.display = 'none';
          //return;
        }
    
      

      $.ajax({
        url: 'https://app.crowdmerch.com.au/crowdmerch/homepage/getDraftOrderItems',
        method: 'POST',
        dataType: 'json',
        data: { draftOrderId:draftOrderId},
        success: (data) => {
          const dhstatus = data.DHStatus;
          if (!data.items || data.items.length === 0) {

            this.$emptylist.style.display = 'none';
            
            let itemsHtml = `
              <div class="list-items">
                <div class="list-items-header">
                  <h3 class="list-items-title">Your list</h3>
                  <div class="yourlist_link">
                    <a href="${continueshoppingurl}">Continue shopping</a>
                  </div>
                </div>
                <div class="list-items-body">no items selected</div>
              </div>
            `;
            this.$items.innerHTML = itemsHtml;
            
          } else {
          
            if (data.status === 'ok' && data.items.length > 0) {
                const wishList = data.items;
               window.draftWishList = wishList;
              localStorage.setItem('wishList', JSON.stringify(wishList));
              console.log('Saved wishlist items to localStorage:', JSON.stringify(wishList));
              // localStorage.setItem('wishList', '');
                console.log('wishlist items',wishList);
                const format = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });    
                let subtotal = 0;
                this.$emptylist.style.display = 'none';
          
                let itemsHtml = '<div class="#list-items">'+
  '    <div class="#list-items-header">'+
  '        <h3 class="#list-items-title">Your list</h3>'+
  '        <div class="yourlist_link"><a href="'+continueshoppingurl+'">Continue shopping</a>'+
  '        <a href="#" id="clear-wishlist" onclick="clearWishlist()">Clear Wishlist</a></div>'+
              '<a href="#" id="download-wishlist" onclick="downloadWishlist()">Download Wishlist</a>' +
            '<a href="#" id="save-wishlist-later" onclick="savelistlater()">Save List for Later</a>' +
  '    </div>'+
  '    <div class="#list-items-body">';
                    
                    for(let i = 0; i < wishList.length; i++){
                      const listItem = wishList[i];
                      //console.log('MMMMMlistItem',listItem);
                      if(listItem.status == 'active'){
                        subtotal += parseFloat(listItem.product.total.replace(/,/g, '')) || 0;;
                        console.log('subtotal',subtotal);
                    itemsHtml+=
          '            <list-item class="#list-item" list-item-row-id="'+(i)+'" list-item-variant-id="'+listItem.variant.id+'" section-id="template--17336574869724__main-list">'+
          '                <div class="#list-item-card">'+
          '                    <!--<a href="/products/'+(listItem.product.handle)+'?variant='+(listItem.variant.id)+'" class="stretched-link"></a>-->'+
          '                    <div class="#list-item-image">'+
          '<figure class=" #media       @aspect-ratio:1x1    " style="">'+
          '        <div class="    #media-image-wrapper        @abs-image   ">'+
          '            <img class="#media-image    @position:center" alt="" loading="lazy" width="1500" height="1500" style="--object-position: ;" src="'+(listItem.variant.image)+'">'+
          '        </div>'+
          '</figure>'+
          '                    </div>'+
          '                    <div class="#list-item-meta">'+
          '                        <h5 class="#list-item-title">'+listItem.product.title+'</h5>'+             
          '                            <p class="#list-item-subtitle">'+listItem.variant.option1+'</p>'+
          '                        <!--<div class="#list-item-price">'+
          '                            <span class="#list-item-price-final">'+(listItem.product.price)+'</span>'+
          '                        </div>-->'+
          '                    </div>'+
          '                </div>'+
          '                <div class="#list-item-side">'+
          '                    <div class="#list-item-view">'+                       
          '<a id="viewproduct" data-productqty="'+listItem.product.qty+'" data-decoration="'+listItem.decID+'" class="#button  @color:default @size:sm" href="/products/'+(listItem.product.handle)+'?variant='+(listItem.variant.id)+'&productqty='+listItem.product.qty+'&decoration='+listItem.decID+'"><span class="#button-inner">'+
          '    <span class="#button-text">'+
          '        View'+
          '    </span>'+
          '</span>'+
          '</a>'+
          '                    </div>'+
          '                    <div class="#list-item-description" data-total="'+listItem.variant.id+'">'+                       
          '                        '+listItem.product.qty+' units<br /> with '+(listItem.decName)+
          '                    </div>'+
                              (dhstatus === "quote"
                                ? '<div class="#list-item-total" data-total="' + listItem.variant.id + '">' + listItem.product.total + '</div>'
                                : '<div class="#list-item-total" data-total="' + listItem.variant.id + '"></div>') +

          '                </div>'+
          '                <a class="#list-item-remove" href="#" data-remove="'+listItem.variant.id+'" aria-label="'+listItem.product.title+'">'+
          '<svg class="#icon">'+
          '    <use href="#svg-icon-x"></use>'+
          '</svg>'+
          '                </a>'+
  '                <a class="edit-wishlist-item" onclick="openModal(event)" href="#" data-edit="'+listItem.variant.id+'" aria-label="'+listItem.product.title+'">'+
  '  <i class="fas fa-pencil-alt"></i>'+
  '                </a>'+
          '            </list-item>';
          
                      }else if(listItem.status == 'inactive'){
                    itemsHtml+=
          '            <list-item class="#list-item" list-item-row-id="'+(i)+'" list-item-variant-id="'+listItem.variant.id+'" section-id="template--17336574869724__main-list">'+
          '                    <div class="#list-item-deleted">'+          
          '                            <p class="#list-item-subtitle">Removed '+listItem.product.title+' <a data-unremove="'+listItem.variant.id+'" href="#">undelete</a></p>'+
          '                    </div>'+
          '                <a class="#list-item-remove" href="#" data-remove="'+listItem.variant.id+'" aria-label="'+listItem.product.title+'">'+
          '<svg class="#icon">'+
          '    <use href="#svg-icon-x"></use>'+
          '</svg>'+
          '                </a>'+
          '            </list-item>';
          
                      }
                    }
                    itemsHtml+=
                      (dhstatus === "quote"
                                ?
          '					<div class="#list-checkout">'+
          '                        <div class="#list-checkout-inner sticky-top">'+
          '                                <subtotal-price class="#list-checkout-subtotal-wrapper" section-id="template--17336574869724__main-cart">'+
          '                                    <div class="#list-checkout-subtotal">'+
          '                                        <div class="main-total">'+
          '                                        <h3 class="#list-checkout-subtotal-title">Subtotal</h3>'+
          '                                        </div>'+
          '                                        <div class="main-subtotal">'+
          '                                        <span class="#list-checkout-subtotal-value one" data-subtotal="">'+
          '                                            <div class="heading">'+format.format(subtotal)+'</div>'+
                                                      '<span>excluding GST</span>'+
          '                                        </span>'+
          '                                        <span class="#list-checkout-subtotal-value two" data-subtotal="">'+
          '                                            <div class="heading">'+format.format(subtotal * 1.1)+'</div>'+
                                                      '<span>including GST</span>'+
          '                                        </span>'+
          '                                        </div>'+
          '                                    </div>'+
          '                                </subtotal-price>'+
          '                                    <div class="#list-checkout-tax-note">'+
          '                                        <span>'+((subtotal * 1.1) >= window.discount_trigger_value ? window.wishlist_discount_message : '' )+'</span>'+
          '                                    </div>'+
          '                        </div>'+
          '                    </div>'
                       : '<div></div>');
                    itemsHtml+='<!--<div><p><strong>List JSON:</strong></p>'+this.getJSONData()+'</div>-->';
                    itemsHtml+
          '    </div>'+
          '</div>';
                   itemsHtml+= (dhstatus === "list_active"
                                ?'<div><p class="wishlistmsg">'+wishlistmsg+'</p></div>'
                                : '<div></div>');
                   // this.$items.innerHTML = itemsHtml;
          
                this.$items.innerHTML = itemsHtml;
                
      } else {
              this.$list.style.display = 'none';
            }
          }
        },
        error: (err) => {
          console.error('AJAX Wishlist Load Error', err);
          this.$list.style.display = 'none';
        }
        });
       
    }*/

      update({ 
        wishList = null, 
        continueshoppingurl = "https://crowdmerch.com.au/collections/essentials-template", 
        wishlistmsg = null, 
        sectionId = "template--17336574869724__main-list",
        dhstatus = null,
        dhtype = null,
        dhproject = "YOUR LIST"
      } = {}) {
        const format = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
        console.log('in list wishlist ',localStorage.getItem('wishList'));
        console.log("DH Status11:", wishlistmsg);
        const navImage = window.shopMetafields.navImgWLP || "";
        // Fallback: if no wishlist is passed, try from localStorage
        if (!wishList) {
          let storedList = localStorage.getItem('wishList');
          if (storedList) {
            wishList = JSON.parse(storedList);
          }
        }
        console.log('dhtype', dhtype);
        console.log('updated-wishList', wishList);
        //localStorage.setItem('wishList', '');
        
        const activeItems = wishList.filter(item => item.status === 'active').length;

        //console.log('Total items:', wishList.length);
        //console.log('Active items:', activeItems);
      
        if (!wishList || wishList.length === 0) {
          if (this.$list) this.$list.style.display = 'none';
          return;
        }
      
        this.$emptylist.style.display = 'none';
      
        let itemsHtml = `
          <div class="#list-items">
            <div class="#list-items-header">
              <h3 class="updatedtitle">${dhproject}</h3>
              <div class="yourlist_link">
                <!--a href="${continueshoppingurl}">Continue shopping</a-->
                <a href="#" id="clear-wishlist" onclick="clearWishlist()">Clear & Start New List</a>
                <a href="#" id="download-wishlist" onclick="downloadWishlist()">Download List Images</a>
                <a href="#" id="save-wishlist-later" onclick="savelistlater()">Save List For Later</a>
              </div>
            </div>
            <div class="#list-items-body">
        `;
      
        let subtotal = 0;
      
        for (let i = 0; i < wishList.length; i++) {
          const listItem = wishList[i];
          console.log('listItem', listItem);
      
          if (listItem.status === 'active') {
            //subtotal += parseFloat(listItem.product.total);
            const rawTotal = listItem.product?.total || '0';
            const total = parseFloat(rawTotal.replace(/,/g, '')) || 0;
            subtotal += total;
            console.log('subtotal ', subtotal);
      
            itemsHtml += `
              <list-item class="#list-item" list-item-row-id="${i}" list-item-variant-id="${listItem.variant.id}" section-id="${sectionId}">
                <div class="#list-item-card">
                  <div class="#list-item-image">
                    <figure class="#media @aspect-ratio:1x1">
                      <div class="#media-image-wrapper @abs-image">
                        <img class="#media-image @position:center" alt="" loading="lazy" width="1500" height="1500" src="${listItem.variant.image}">
                      </div>
                    </figure>
                  </div>
                  <div class="#list-item-meta">
                    <h5 class="#list-item-title">${listItem.product.title}</h5>
                    <p class="#list-item-subtitle">${listItem.variant.option1}</p>
                  </div>
                </div>
                <div class="#list-item-side">
                  <div class="#list-item-view">
                    <a id="viewproduct" data-productqty="${listItem.product.qty}" data-decoration="${listItem.decID}" class="#button @color:default @size:sm" href="/products/${listItem.product.handle}?variant=${listItem.variant.id}&productqty=${listItem.product.qty}&decoration=${listItem.decID}">
                      <span class="#button-inner">
                        <span class="#button-text">View</span>
                      </span>
                    </a>
                  </div>
                  <div class="#list-item-description" data-total="${listItem.variant.id}">
                    <span class="updateqty">${listItem.product.qty}</span> units<br /> with ${listItem.decName}
                  </div>
                  <div class="#list-item-total" data-total="${listItem.variant.id}">${listItem.product.total}</div>
                </div>
                 ${dhtype != "ORDERED" ? `
                <a class="edit-wishlist-item" onclick="openModal(event)" href="#" data-edit="${listItem.variant.id}" aria-label="${listItem.product.title}">
                  <i class="fas fa-pencil-alt"></i>
                </a>` : ''}  
                <a class="#list-item-remove" href="#" data-remove="${listItem.variant.id}" aria-label="${listItem.product.title}">
                  <svg class="#icon">
                    <use href="#svg-icon-x"></use>
                  </svg>
                </a>
                
              </list-item>
            `;
          } else if (listItem.status === 'inactive') {
            itemsHtml += `
              <list-item class="#list-item" list-item-row-id="${i}" list-item-variant-id="${listItem.variant.id}" section-id="${sectionId}">
                <div class="#list-item-deleted">
                  <p class="#list-item-subtitle">Removed ${listItem.product.title} <a data-unremove="${listItem.variant.id}" href="#">undelete</a></p>
                </div>
                <a class="list-item-remove" href="#" onclick="deleteItem(event)" data-productqty="${listItem.product.qty}" data-remove="${listItem.variant.id}" aria-label="${listItem.product.title}">
                  <svg class="#icon">
                    <use href="#svg-icon-x"></use>
                  </svg>
                </a>
              </list-item>
            `;
          } else if (listItem.status === 'discontinued') {   // ← ADD THIS BLOCK
            itemsHtml += `
              <list-item class="#list-item" list-item-row-id="${i}" list-item-variant-id="discontinued-${i}" section-id="${sectionId}" style="border: 2px solid red; border-radius: 6px; background: #fff5f5; display:flex; padding: 10px; margin-bottom: 8px;">
                <div class="#list-item-card">
                  <div class="#list-item-image">
                    <figure class="#media @aspect-ratio:1x1">
                      <div class="#media-image-wrapper @abs-image">
                        <div style="width:80px;height:80px;background:#eee;display:flex;align-items:center;justify-content:center;border-radius:4px;">
                          
                        </div>
                      </div>
                    </figure>
                  </div>
                  <div class="#list-item-meta">
                    <h5 class="#list-item-title" style="color:red;">${listItem.product.title || 'Discontinued Product'}</h5>
                    <p class="#list-item-subtitle" style="color:red; font-size:13px;">This product is no longer available. Please remove it.</p>
                  </div>
                </div>
                <div class="#list-item-side">
                  <div class="#list-item-description">${listItem.product.qty} units</div>
                  <div class="#list-item-total">—</div>
                </div>
                <a class="#list-item-remove" href="#" data-remove="${listItem.variant.id || ''}" aria-label="Remove discontinued product">
                  <svg class="#icon"><use href="#svg-icon-x"></use></svg>
                </a>
              </list-item>
            `;
          }

        }
      
        itemsHtml += `
              
              <div class="#list-checkout">
                <div class="#list-checkout-inner sticky-top">
                  <subtotal-price class="#list-checkout-subtotal-wrapper" section-id="template--17336574869724__main-cart">
                    <div class="#list-checkout-subtotal">
                      <div class="main-total">
                        <h3 class="#list-checkout-subtotal-title">Subtotal</h3>
                      </div>
                      <div class="main-subtotal">
                        <span class="#list-checkout-subtotal-value one" data-subtotal="">
                          <div class="heading">${format.format(subtotal)}</div>
                          <span>excluding GST</span>
                        </span>
                        <span class="#list-checkout-subtotal-value two" data-subtotal="">
                          <div class="heading">${format.format(subtotal * 1.1)}</div>
                          <span>including GST</span>
                        </span>
                      </div>
                    </div>
                  </subtotal-price>
                  <div class="#list-checkout-tax-note">
                    <span>${(subtotal * 1.1) >= window.discount_trigger_value ? window.wishlist_discount_message : ''}</span>
                  </div>
                </div>
              </div>
            ${dhstatus === "list_active" && wishlistmsg ? `<div><p class="wishlistmsg">${wishlistmsg}</p></div>` : ''}
            </div>`;

          //   itemsHtml += `
                
          //  `;

        // if (dhtype === 'QUOTED') {
        //   itemsHtml += `
        //     <div class="wishlist-place-order">
        //       <button id="place-order-btn" onclick="placeOrder(event)" class="btn btn-primary" style="margin-top: 20px;">
        //         PLACE ORDER REQUEST
        //       </button>
        //     </div>
        //   `;EMAIL QUOTE PDF
        // }
        if (dhtype === 'LIST' || dhtype === 'QUOTED') {
          itemsHtml += `
            <div class="wishlist-get-quote">
            <a class="add-product-btn" href="https://crowdmerch.com.au/collections/products">
                  ADD A PRODUCT
                </a>  
            <button id="get-quote-btn" onclick="getQuote(event)" class="btn btn-primary">
                EMAIL AN INSTANT QUOTE
              </button>
            </div>
            <div class="image-wrap">
            <img class="my-art" src="${navImage}" />
            </div>
          `;
        }
        if (dhtype === 'ORDERED') {
          itemsHtml += `
            <div class="modify-order">
              <button id="modify-order-btn" onclick="placeOrder(event)" class="btn btn-primary" style="margin-top: 20px;">
                MODIFY ORDER REQUEST
              </button>
            </div>
          `;
        }
          itemsHtml += `</div>`;
        
      
        this.$items.innerHTML = itemsHtml;

        if (activeItems === wishList.length) {
          //$(".yourlist_link").css("display", "block");
        } else {
          //$(".yourlist_link").css("display", "none");
        }
      }
  });

    document.addEventListener('DOMContentLoaded', () => {
      const productBtn = document.querySelector('.productcont');
      if (productBtn) {
        productBtn.addEventListener('click', function () {
          window.location.href = 'https://crowdmerch.com.au/collections';
        });
      }
    });

  customElements.define('s-subtotal-price1', class extends baseComponent.default {
    render() {
      this.listenTo('listChange', (e, data) => {
        const source = data.html.querySelector('subtotal-price');
        this.replaceChildren(...source.childNodes);
      })
    }
  });

  customElements.define('list-item', class extends baseComponent.default {
    elements = {
      plusButton: '[data-inc]',
      minusButton: '[data-dec]',
      removeButton: '[data-remove]',
      unremoveButton: '[data-unremove]',
      qtyInput: '[data-input]',
      linePrice: '[data-total]',
      
    }


    render() {
      this.sectionId = this.getAttribute('section-id');
      this.lineIndex = this.getAttribute('line-item-index');
      this.variantId = this.getAttribute('list-item-variant-id');
      this.rowId = this.getAttribute('list-item-row-id');
      //this.qtyValue = +this.$qtyInput.value;
      //this.variantQtyLimit = +this.$qtyInput.max;
      this._handleInteractions();
    };

    _handleInteractions() {
      //this.$plusButton.addEventListener('click', () => this._validateInput(1));
      //this.$minusButton.addEventListener('click', () => this._validateInput(-1));
      //this.$qtyInput.addEventListener('change', () => this._validateInput());
      this.$removeButton.addEventListener('click', this._removeItem.bind(this));
      //this.$clearButton.addEventListener('click', this._clearItems.bind(this));
      if(this.$unremoveButton)this.$unremoveButton.addEventListener('click', this._unremoveItem.bind(this));
    };

    _validateInput(input) {
      const value = input ? this.qtyValue + input : +this.$qtyInput.value;
      if (value < 1 || (this.variantQtyLimit && value > this.variantQtyLimit)) {
        // alert('Incorrect quantity!')
        // console.log('wrong quanity')
        this.$qtyInput.value = this.qtyValue;
        return
      }
      this.qtyValue = value;
      this._updateUI();
      this._updateListRequest(value);
    };

    _removeItem(e) {
      e.preventDefault();
    
      let wishList = localStorage.getItem('wishList');
      console.log('removewishList (raw)', wishList);
    
      if (wishList) {
        // Parse the JSON string into an array
        wishList = JSON.parse(wishList);
    
        const newWishList = [];

        let removedItem = null;
        let wasDiscontinued = false;
        console.log('this.rowId:', this.rowId);
    
        for (let i = 0; i < wishList.length; i++) {
          if (i == this.rowId) {
            removedItem = wishList[i];
            console.log('matched item status:', wishList[i].status);

            if (wishList[i].status === 'discontinued') {
              // ← skip inactive, go straight to deleted
              wasDiscontinued = true;
              wishList[i].status = 'deleted';
            } else if (wishList[i].status === 'active') {
              wishList[i].status = 'inactive';
            } else {
              wishList[i].status = 'deleted';
            }
          }
    
          if (wishList[i].status !== 'deleted') {
            newWishList.push(wishList[i]);
          }
        }
    
        // Save the updated array back to localStorage
        localStorage.setItem('wishList', JSON.stringify(newWishList));

        console.log('wasDiscontinued:', wasDiscontinued);
        console.log('removedItem:', removedItem);

        // ── Only fires for discontinued items ──
        if (wasDiscontinued && removedItem) {
            const draftOrderId = localStorage.getItem('ActiveWL');
            console.log('firing AJAX, draftOrderId:', draftOrderId);
            
            if (draftOrderId) {
                $.ajax({
                    url: 'https://app.crowdmerch.com.au/crowdmerch/homepage/removeDiscontinuedItem',
                    method: 'POST',
                    data: {
                        draftOrderId: draftOrderId
                    },
                    success: (res) => {
                        console.log('Discontinued item removed from draft order:', res);
                        location.reload();
                    },
                    error: (err) => {
                        console.error('Failed to remove discontinued item:', err);
                    }
                });
            }
        }

      }
    
      document.querySelector("main-list").update();
    }


    _clearItems(e){
        e.preventDefault();
      //if (confirm("Are you sure you want to remove all items from your wishlist?")) {
        let wishList = localStorage.getItem('wishList');
        if(wishList){
          const newWishList = [];
          wishList = JSON.parse(wishList);
          console.log(wishList.length);
          for(let i = 0; i < wishList.length; i++){
            //if(i == this.rowId){
              if(wishList[i].status == 'active')wishList[i].status= 'inactive';       
              else wishList[i].status= 'deleted';
            //}
            if(wishList[i].status != 'deleted'){
              newWishList.push(wishList[i]);
            }
          }
          localStorage.setItem('wishList', JSON.stringify(newWishList));
        }
        document.querySelector("main-list").update();
      //}      
    }

    _unremoveItem(e) {
      e.preventDefault();
      let wishList = localStorage.getItem('wishList');
      if(wishList){
        wishList = JSON.parse(wishList);
        for(let i = 0; i < wishList.length; i++){
          if(i == this.rowId){
            wishList[i].status= 'active';       
          }
        }
        localStorage.setItem('wishList', JSON.stringify(wishList));
      }
      document.querySelector("main-list").update();
    };

    _update(){
      console.log(localStorage);
    }

    _updateUI() {
      this._updateInputValue();
      this._updateButtons();
    };
    
    _updateInputValue() {
      this.$qtyInput.value = this.qtyValue;
    };

    _updateButtons() {
      this.$plusButton.disabled = this.qtyValue === this.variantQtyLimit;
      this.$minusButton.disabled = this.qtyValue === 1;
    };

    _updateListRequest (qty) {
      this.setAttribute('loading', '');
      const body = JSON.stringify({
        id: this.variantId,
        quantity: qty,
        sections: this.sectionId,
        sections_url: this.getAttribute('list-url')
      });
      const fetchConfig = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/json` }
      };
      fetch(`${routes.list_change_url}`, {...fetchConfig, ...{ body }})
        .then((response) => {
          return response.json();
        })
        .then((state) => {
          const html = state.sections[this.sectionId];
          const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
          this._acceptChanges(parsedHtml, qty);
          this.removeAttribute('loading');
        })
        .catch((e) => { console.error(e)});
    };

    _acceptChanges(html, qty) {
      // console.log('sending evt');
      this.forwardEvent('listChange', {
        html: html,
        remove: qty === 0,
        variantId: this.variantId
      });
      if (qty === 0) {
        this.remove();
        return;
      }
      this._updateLinePrice(html);
    };

    _updateLinePrice(html) {
      const source = html.querySelector(`[data-total="${this.variantId}"]`);
      this.$linePrice.replaceChildren(...source.childNodes);
    };
  });


})();